import { Provider } from '@/types/supabase';

export function normalizeProviderCategory(value: string | null | undefined): string | null {
  if (typeof value !== 'string') {
    return null;
  }

  const normalized = value.trim().toLowerCase();
  return normalized === '' ? null : normalized;
}

export function getProviderCategoryKeys(provider: Pick<Provider, 'category' | 'categories'>): string[] {
  const categoryKeys = new Set<string>();

  for (const category of provider.categories ?? []) {
    const normalizedCategory = normalizeProviderCategory(category);
    if (normalizedCategory) {
      categoryKeys.add(normalizedCategory);
    }
  }

  return Array.from(categoryKeys);
}